import React from "react"
import { useTranslation } from "next-i18next"
import StyledModal, { ModalProps } from "../StyledModal"
import close from "../../assets/imgs/home/bg_x.png"

interface CancelConfirmModalProps extends ModalProps {
    onCancel: () => void
}

export const CancelConfirmModal = ({ onCancel, isOpen, onRequestClose }: CancelConfirmModalProps) => {
    const { t: tCommon } = useTranslation("common")
    const { t: tMyAccount } = useTranslation("my-account")

    return (
        <StyledModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <div className="relative mx-auto h-[337px] w-[300px] rounded-[11px] border border-[#808080] bg-[#F8F8F8] text-center lg:h-[282px] lg:w-[468px]">
                <div className="absolute right-[13px] top-[13px] text-right">
                    <img src={close.src} onClick={onRequestClose} className="w-[15px] hover:opacity-50 lg:w-[20px]" />
                </div>
                <div className="pt-[58px] text-20 font-bold leading-6 text-neutral-1-500 lg:pt-[41px] lg:text-28">
                    {tMyAccount("cancelConfirmation.label")}
                </div>
                <div
                    className="mx-auto mt-[21px] max-w-[230px] text-base leading-[19px] text-neutral-1-500 lg:mt-[25px] lg:max-w-[348px]"
                    dangerouslySetInnerHTML={{ __html: tMyAccount("cancelConfirmation.description") }}
                ></div>
                <div className={"b-flex-center  mt-[42px] flex-col lg:mt-[35px] lg:flex-row"}>
                    <button
                        onClick={onRequestClose}
                        className={
                            "h-[31px] w-[143px] rounded-[3px] bg-accent-1 text-14 font-bold text-neutral-1 hover:text-primary lg:mr-3"
                        }
                    >
                        {tCommon("button.confirm")}
                    </button>
                    <button
                        onClick={onCancel}
                        className={
                            "mt-5 h-[31px] w-[143px] rounded-[3px] border border-neutral-1 text-14 font-bold text-neutral-1 hover:text-accent-1 lg:mt-0"
                        }
                    >
                        {tCommon("button.cancel")}
                    </button>
                </div>
            </div>
        </StyledModal>
    )
}
